import React from 'react';
import PropTypes from 'prop-types';

const BatchStatus = ({ data }) => {
  let displayText = "";
  switch (data){
    case 0:
      displayText = "Opin";
      break;
    case 2:
      displayText = "Closed";
      break;
    case 3:
      displayText = "Canceled";
      break;
    case 4:
      displayText = "Aborted";
      break;
    case 5:
      displayText = "Processed";
      break;
    default:
      displayText = "Unknown";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

BatchStatus.propTypes = {
  data: PropTypes.number,
};

export default BatchStatus;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Batch/BatchStatus.js